import React, { useState } from 'react';

type VitalSliderDialogProps = {
  title: string;
  name: string;
  initial: number;
  max: number;
  onClose: () => void;
  onApply: (value: number) => void;
};

export function VitalSliderDialog({ title, name, initial, max, onClose, onApply }: VitalSliderDialogProps) {
  const ceiling = Math.max(0, max);
  const [value, setValue] = useState(Math.max(0, Math.min(ceiling, initial)));

  return (
    <div
      className="vital-edit-popup-overlay"
      data-gamepad-overlay="modal"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="vital-slider-title"
    >
      <div className="vital-edit-popup-content vital-edit-popup-slider" onClick={(event) => event.stopPropagation()}>
        <h2 id="vital-slider-title" className="vital-edit-popup-title">{title}</h2>
        <p className="vital-edit-char-name">{name}</p>
        <span className="vital-edit-value-display">
          {value} <span className="vital-edit-max">/ {ceiling}</span>
        </span>
        <div className="vital-edit-slider-row">
          <button
            type="button"
            className="vital-edit-btn vital-edit-btn-minus"
            onClick={() => setValue((current) => Math.max(0, current - 1))}
            aria-label="Wert verringern"
          >
            −
          </button>
          <div className="vital-edit-slider-track">
            <div className="vital-edit-slider-bar" aria-hidden>
              <div
                className="vital-edit-slider-fill is-health"
                style={{ width: `${ceiling > 0 ? (value / ceiling) * 100 : 0}%` }}
              />
            </div>
            <input
              type="range"
              className="vital-edit-slider"
              min={0}
              max={ceiling}
              step={1}
              value={value}
              aria-label="HP"
              aria-valuetext={`${value} von ${ceiling}`}
              onChange={(event) => setValue(Number(event.target.value))}
            />
          </div>
          <button
            type="button"
            className="vital-edit-btn vital-edit-btn-plus"
            onClick={() => setValue((current) => Math.min(ceiling, current + 1))}
            aria-label="Wert erhoehen"
          >
            +
          </button>
        </div>
        <div className="vital-edit-slider-ends" aria-hidden>
          <span>0</span>
          <span>{ceiling}</span>
        </div>
        <div className="vital-edit-popup-actions">
          <button type="button" className="vital-edit-btn-cancel" data-gamepad-dismiss onClick={onClose}>Abbrechen</button>
          <button type="button" className="vital-edit-btn-fill" onClick={() => setValue(ceiling)}>Auffüllen</button>
          <button type="button" className="vital-edit-btn-apply" onClick={() => onApply(value)}>Übernehmen</button>
        </div>
      </div>
    </div>
  );
}
